var MDB = window.MDB || {};;
(function ($, global) {
    MDB.WidgetEditor = MDB.WidgetEditor || {};
    MDB.WidgetEditor.Model = Model;

    var types = MDB.WidgetEditor.Model.Types = {
        Line: 1,
        Map: 2,
        Bar: 3,
        Pie: 4,
        Table: 5,
        Map_pc: 6,
        Gauge: 7,
        Radar: 8,
        Waterfall: 9,
        HorizontalWaterfall: 10,
        Funnel: 11,
        TableWithMoment: 12,
        Tableau: 13,
        TableExtended: 14,
        StackedBars: 15,
        LinearGauge: 16
    };

    MDB.WidgetEditor.Model.ColoredSeriesCharts =
    [
        types.Line,
        types.Bar,
        types.Pie,
        types.Funnel,
        types.Radar,
        types.Waterfall,
        types.HorizontalWaterfall,
        types.StackedBars
    ];

    function Model(metadata) {
        this.type = MDB.WidgetEditor.Model.Types.Line;
        this.metadata = metadata;
        this.columns = [];
        this.groupBy = [];
        this.whereGroups = [];
        this.customQueryDashboardFilterIds = [];
        this.category = false;
        this.tables = [];
        this.allowCustomPalette = true;
        this.paletteId = null;
        this.paletteColors = [];

        this.dashboardDateFilterAttribute = null;
        this.dashboardDivisionFilterAttribute = null;
        this.isGenerateSummaryEnabled = false;

    }

    Model.prototype = {
        constructor: Model,
        getData: function () {
            var conf = {
                Type: this.type,
                Columns: this._getColumnForExport(),
                GroupBy: this.groupBy,
                Tables: this.getTableData(),
                WhereConditions: this.getWhereData(),
                CustomQueryDashboardFilterIds : this.customQueryDashboardFilterIds,
                IsGenerateSummaryEnabled: !!this.isGenerateSummaryEnabled,
                DashboardDateFilterAttributeId: this.dashboardDateFilterAttribute && this.dashboardDateFilterAttribute.Id,
                DashboardDivisionFilterAttributeId: this.dashboardDivisionFilterAttribute && this.dashboardDivisionFilterAttribute.Id,
            };

            if (this.allowCustomPalette) {
                conf.PaletteId = this.paletteId;
                conf.Colors = this.paletteColors.map(function(color) {
                    return color.ColorValue 
                });
            } else {
                conf.PaletteId = null;
            }
            return conf;
        },
        _getColumnForExport:function() {
            var res = [];
            this.columns.forEach(function(col) {
                var c = $.extend({}, col);
                // remove some of the properties
                if(c._events) {
                    c._events = null;  delete c._events; 
                }
                res.push(c);
            });
            return res;
        },
        isValid: function () {
            return this.columns.length > 0 && this.groupBy.length > 0;
        },

        setType: function (type) {

            this.type = type;
        },
        getType: function () {
            return this.type; 
        },
        getCategory: function () {
            return this.category; 
        },
        setCategory: function (category) {
            this.category = category;
        },
        addDashboardFilter: function (dateField, attrId, groupId, attrType) {
            if (dateField) {
                this.dashboardDateFilterAttribute = this.metadata.AttributesById[attrId];
            } else {
                this.dashboardDivisionFilterAttribute = this.metadata.AttributesById[attrId];
            }
        },

        removeWhereColumn: function (internalId) {
            this.whereGroups.forEach(function (group) {
                for (var i = 0; i < group.length; i++) {
                    if (group[i] && group[i]._id == internalId) {
                        // remove element
                        group.splice(i, 1);
                        return false;
                    }
                }
            });
        },
        addWhereColumn: function (attrId, groupId, attrType) {
            if (attrType == 'tag') {
                return;
            }

            groupId = parseInt(groupId, 10);
            var g = this.whereGroups[groupId];
            if (!g || this.whereGroups.length <= groupId) {
                // newgroup
                g = [];
                this.whereGroups.push(g);
            }
            // add
            var condition = new MDB.WidgetEditor.WhereFilter.WhereCondition(attrId, this);
            g.push(condition);
            return condition;
        },
        setCustomQueryDashboardFilterIds: function(ids) {
            this.customQueryDashboardFilterIds = ids;
        },
        addGroupBy: function (attrId, type, srcConfig) {
            var col = null;
            if (type == 'tag') {
                col = this.metadata.TagsById[attrId];
            } else {
                col = this.metadata.AttributesById[attrId];
            }
            
            this.groupBy.push(new Column({
                Source: col,
                Type: type || 'attribute',
                Id: col.Id,
                Name: col.Name,
                FilterValue: null,
                GroupByHoursFromDayCount: srcConfig && srcConfig.GroupByHoursFromDayCount
            }));
        },
        addColors: function (value) {
            var collection = this.paletteColors;
            value.forEach(function (color) {
                collection.push(new Color({ ColorValue: color }));
            });
        },
        clearGroupBy: function () {
            this.groupBy = [];
        },
        removeGroupBy: function (attrId, internalId) {
            var collection = this.groupBy;
            if (!internalId) {
                throw new Error("InternalId must be specified");
            }
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //remove
                    collection.splice(i, 1);
                    break;
                }
            }
        },
        updateColor: function (internalId, value) {
            var collection = this.paletteColors;
            if (!internalId) {
                throw new Error("InternalId must be specified");
            }

            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //update
                    collection[i].ColorValue = value;
                    break;
                }
            }
        },
        removeColor: function () {
            var collection = this.paletteColors;
            collection.splice(collection.length - 1, 1);
        },
        addColumn: function (attrId, type) {
            var col;
            if (type == 'tag') {
                col = this.metadata.TagsById[attrId];
            } else if (type == 'expression') {
                col = {
                    Id: '00000000-0000-0000-0000-000000000000',
                    Name: 'Expr'
                };
            } else {
                col = this.metadata.AttributesById[attrId];
            }

            if(!col) {
                console.warn("Specified column with attributeId: "+attrId+" was not found in the metadata. Column will be ignored.");
                return null;
            }
			
			
            var column = new Column({
                Source: col,
                Type: type || 'attribute',
                Id: col.Id,
                Name: col.Name,
                Expression: null,
                FilterValue: null,
                Operation: 1 //'COUNT'
            });
            this.columns.push(column);
            return column;
        },
        removeColumn: function (attrId, internalId) {
            var collection = this.columns;
            if (!internalId) {
                throw new Error("InternalId must be specified");
            }
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //remove
                    collection.splice(i, 1);
                    break;
                }
            }
        },
        addColumnFilterAttribute: function (internalId, attrId) {
            var attr = this.metadata.AttributesById[attrId];
            if (!attr) {
                return;
            }
            var collection = this.columns;
            collection.forEach(function (col) {
                if (col._id == internalId) {
                    // add
                    col.FilterAttributeId = attrId;
                    col.FilterAttribute = attr;
                    return false;
                }
            });

        },
        isAddTableAllowed: function (entityId) {
            if (this.tables.length == 0) {
                return true;
            }
            var valid = false;
            this.tables.forEach(function (tbl) {
                if (tbl.hasRelationWithEntity(entityId)) {
                    valid = true;
                    return false;
                }
            });
            return valid;
        },
        moveColumn: function (internalId, direction) {
            var collection = this.columns;
            var index = -1;
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //remove
                    index = i;
                    break;
                }
            }
            if (index == -1) {
                return;
            }
            var tmp;
            if (direction == 'up' && index > 0) {
                tmp = collection[index];
                collection[index] = collection[index - 1];
                collection[index - 1] = tmp;
            } else if (direction == 'down' && index < (collection.length - 1)) {
                tmp = collection[index];
                collection[index] = collection[index + 1];
                collection[index + 1] = tmp;
            }
        },
        moveTableUp: function (internalId) {
            var collection = this.tables;
            if (!internalId) {
                throw new Error("InternalId must be specified");
            }
            var index = -1;
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //remove
                    index = i;
                    break;
                }
            }
            if (index != -1 && index > 0) {
                var tmp = collection[index];
                collection[index] = collection[index - 1];
                collection[index - 1] = tmp;
            }
        },
        moveTableDown: function (internalId) {
            var collection = this.tables;
            if (!internalId) {
                throw new Error("InternalId must be specified");
            }
            var index = -1;
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //remove
                    index = i;
                    break;
                }
            }
            if (index != -1 && index < (collection.length - 1)) {
                var tmp = collection[index];
                collection[index] = collection[index + 1];
                collection[index + 1] = tmp;
            }
        },
        removeTable: function (internalId) {
            var collection = this.tables;
            if (!internalId) {
                throw new Error("InternalId must be specified");
            }
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] && collection[i]._id == internalId) {
                    //remove
                    collection.splice(i, 1);
                    break;
                }
            }
        },
        addTable: function (entityId, entityName) {
            var metadata = this.metadata;
            var entities = metadata.Entities;
            if (!entityId && entityName) {
                //find entity
                Object.keys(entities).forEach(function (key) {
                    if (entities[key] && entities[key].Name == entityName) {
                        entityId = key;
                        return false;
                    }
                });
            }
            if (!entityId) {
                return;
            }

            if (!this.tables[entityId]) {
                var entity = entities[entityId];
                if (!entity) {
                    return;
                }

                var relations = [];
                // find relations
                for (var i = 0; i < metadata.EntityRelations.length; i++) {
                    var er = metadata.EntityRelations[i];
                    if (er.ForeignEntityId == entityId) {
                        relations.push({
                            _id: 'R' + relations.length,
                            Attribute: metadata.AttributesById[er.ForeignAttributeId],
                            TargetEntity: entities[er.PrimaryEntityId],
                            TargetAttribute: metadata.AttributesById[er.PrimaryAttributeId],
                        });
                    } else if (er.PrimaryEntityId == entityId) {
                        relations.push({
                            _id: 'R' + relations.length,
                            Attribute: metadata.AttributesById[er.PrimaryAttributeId],
                            TargetEntity: entities[er.ForeignEntityId],
                            TargetAttribute: metadata.AttributesById[er.ForeignAttributeId],
                        });
                    }
                }

                // add
                var table = new Table({
                    metadata: this.metadata,
                    SelectedRelation: null,
                    SelectedRelationType: 'INNER',
                    SourceEntity: entity,
                    Relations: relations
                });
                this.tables.push(table);
                return table;
            }
        },

        getGroupBy: function () {
            return this.groupBy;
        },
        getColumns: function () {
            return this.columns;
        },
        getCollections: function () {
            var me = this;
            var result = [];
            this.tables.forEach(function (table) {
                result.push(table);
            });

            return result;
        },

        getWhereData: function () {
            var res = [];
            this.whereGroups.forEach(function (group) {
                if (!group) {
                    return;
                }
                var g = [];
                group.forEach(function (condition) {
                    g.push({
                        Id: condition.Id,
                        Value1: condition.Value1,
                        Value2: condition.Value2,
                        FilterType: condition.FilterType
                    });
                });
                if (g.length > 0) {
                    res.push(g);
                }
            });
            return res;
        },
        getTableData: function () {
            // get table data to send to the api
            if (this.tables.length == 0) {
                return [];
            }
            var res = [];

            this.tables.forEach(function (tbl) {
                res.push({
                    Id: tbl.SourceEntity.Id,
                    JoinType: tbl.SelectedRelationType || 'INNER',
                    AttributeId: tbl.SelectedRelation && tbl.SelectedRelation.Attribute.Id,
                    JoinWithTableId: tbl.SelectedRelation && tbl.SelectedRelation.TargetEntity.Id,
                    JoinTableAttributeId: tbl.SelectedRelation && tbl.SelectedRelation.TargetAttribute.Id,
                });
            });

            res[0].AttributeId = null;
            res[0].JoinWithTableId = null;
            res[0].JoinTableAttributeId = null;
            return res;
        },
        getColors: function () {
            return this.paletteColors;
        },
        clearColors: function () {
            this.paletteColors = [];
        },
        setAllowCustomPalette: function(value) {
            this.allowCustomPalette = value;
        },
        getPaletteId: function () {
            return this.paletteId;
        },
        setPaletteId: function (id) {
            this.paletteId = id;
        }
    };
    function Table(cfg) {
        if (!cfg) {
            cfg = {};
        }
        var me = this;
        this._id = 'T' + (Column._idCount++);
        Object.keys(cfg).forEach(function (prop) {
            me[prop] = cfg[prop];
        });
        //SelectedRelation: null,
        //SourceEntity: entity,
        //Relations: relations
    }

    Table.prototype = {
        constructor: Table,
        getAvailableRelations: function () {
            return this.Relations;
        },
        selectRelation: function (relation) {
            this.SelectedRelation = relation;
        },
        hasRelationWithEntity: function (entityId) {
            //TODO: check if we have a valid relation with the last table
            var valid = true;
            //if (!this.Relations || this.Relations.length == 0) return false;
            //this.Relations.forEach(function(relation) {
            //});
            return valid;
        },
        getRelationsForTables: function (tables) {

            var res = [];
            if (!this.Relations || this.Relations.length == 0) {
                return res;
            }
            this.Relations.forEach(function (relation) {
                var found = false;
                for (var i = 0; i < tables.length; i++) {
                    if (relation.TargetEntity && tables[i].SourceEntity.Id == relation.TargetEntity.Id) {
                        res.push(relation);
                    }
                }
            });
            return res;
        },

        renderTo: function (target, previousTables) {
            this.render(previousTables).appendTo(target);
        },
        render: function (previousTables) {
            var tbl = this;
            // TODO: select a relation with the table: previousTable
            var html = [
                '<div class="attribute" data-iid="' + tbl._id + '" data-entityid="' + tbl.SourceEntity.Id + '">',
                '<div class="row">',
                '  <div class="col-xs-12">',
                '    <span class="fa fa-trash-o btn-delete"></span>',
                '    <span class="fa fa-chevron-up btn-up"></span>',
                '    <span class="fa fa-chevron-down btn-down"></span>',
                '    ' + tbl.SourceEntity.Name,
                '    <span class="fa fa-gears btn-advanced" title="' + MDB.loadResourceString('Widget_Edit_Button_Advanced_Tooltip') + '"></span>' +
                  '  </div>',
                '</div>',
                /* relation: */
                '<div class="row relation">',
                '  <div class="col-xs-12">',
                '    <select class="relation-join form-control">',
                '      <option value="">' + MDB.loadResourceString('Widget_Edit_RelationDropdown_DefaultOption') + '</option>',
                '    </select>',
                '    <select class="relation-join-type form-control">',
                '      <option value="INNER">INNER JOIN</option>',
                '      <option value="LEFT">LEFT JOIN</option>',
                '      <option value="RIGHT">RIGHT JOIN</option>',
                '      <option value="OUTER">OUTER JOIN</option>',
                '    </select>',
                '  </div>',
                '</div>',
                '</div>'
            ].join('');
            var d = $(html);
            if (!previousTables || previousTables.length == 0) {
                d.find('.relation').remove();
                d.find('.btn-advanced').hide();

            } else {
                // wire relation dropdowns
                var joinType = d.find('.relation-join-type');
                if (tbl.SelectedRelationType) {
                    joinType.val(tbl.SelectedRelationType);
                }
                joinType.bind('change', function (e) {
                    tbl.SelectedRelationType = $(this).val();
                    $('body').trigger('preview-sql');
                });
                joinType = null;

                var relations = this.getRelationsForTables(previousTables);
                var select = d.find('.relation-join');
                relations.forEach(function (relation) {
                    try {
                        // add option
                        var tooltip = tbl.SourceEntity.Name + '.' + relation.Attribute.Name + ' = ' + relation.TargetEntity.Name + '.' + relation.TargetAttribute.Name;
                        var name = relation.TargetEntity.Name + '.' + relation.Attribute.Name;
                        $('<option />', {
                            value: relation._id,
                            'data-tooltip': tooltip
                        }).text(name).appendTo(select);
                    } catch (e) {
                        // oops ...
                    }
                });
                if (relations && relations.length > 0) {
                    // default to the first
                    tbl.SelectedRelation = relations[0];

                    d.find('.btn-advanced').bind('click', function () {
                        var open = !d.data('advancedopened');
                        d.data('advancedopened', open);
                        if (open) {
                            d.find('.relation').show();
                        } else {
                            d.find('.relation').hide();
                        }
                    });
                    d.find('.relation').hide();
                } else {
                    // no adanced view
                    d.find('.btn-advanced').hide();
                }
                /*if (relations && relations.length == 1) {
                    // only 1 relation, autoselect
                    tbl.SelectedRelation = relations[0];
                }*/
                relations = null;

                if (tbl.SelectedRelation) {
                    select.val(tbl.SelectedRelation._id);
                }
                select.bind('change', function (e) {
                    var id = $(this).val();
                    var tt = '';
                    if (!id) {
                        tbl.SelectedRelation = null;
                    } else if (tbl.Relations) {
                        // find
                        tbl.Relations.forEach(function (relation) {
                            if (relation._id == id) {
                                tbl.SelectedRelation = relation;
                                tt = select.find('option[value="' + id + '"]').data('tooltip') || '';
                                return false;
                            }
                        });
                    }
                    $(this).attr('title', tt);
                    $('body').trigger('preview-sql');
                });
                setTimeout(function () {
                    select.trigger('change'); 
                }, 0);
            }

            return d;
        }
    };

    function Column(cfg) {
        if (!cfg) {
            cfg = {};
        }
        var me = this;
        Column.superclass.call(me);
        this._id = 'C' + (Column._idCount++);
        Object.keys(cfg).forEach(function (prop) {
            me[prop] = cfg[prop];
        });
    }

    Column.superclass = EventEmitter;
    Column._idCount = 0;
    Column.prototype = new EventEmitter();
    $.extend(Column.prototype, {
        constructor: Column,
        renderGroupByHtml: function() {
            var gb = this;
            
            //DateTime columns should get an extra set of advanced options related to date groupings
            var isDateTime = gb.Source && 
                ['DateTime', 'DateTime?'].indexOf(gb.Source.Type) !== -1;
            
            var content = [
                '<div class="attribute" data-iid="' + gb._id + '" data-attributeid="' + gb.Id + '">',
                    '<div class="row">',
                        '<div class="col-xs-12">',
                            '<span class="fa fa-trash-o btn-delete"></span>'
            ];
            
            if(isDateTime){
                content.push(
                    ' <span class="fa fa-gears btn-advanced" title="' + MDB.loadResourceString('Widget_Edit_Button_Advanced_Tooltip') + '"></span>'
                );
            }
            
            content.push(' ' + gb.Name);
            
            //Close our top container
            content.push('</div>');
            
            //Close our row
            content.push('</div>');
            
            if(isDateTime){
                content.push('<div class="row advanced hidden">');
                content.push('<div class="col-xs-8">');
                
                content.push('<input class="advanced-field" data-field="GroupByHoursFromDayCount" type="number"');
                content.push(' placeholder="' + MDB.loadResourceString('WidgetQueryGroupByConfigurationColumn_GroupByHoursFromDayCount_Tooltip') + '"');
                content.push(' title="' + MDB.loadResourceString('WidgetQueryGroupByConfigurationColumn_GroupByHoursFromDayCount_Tooltip') + '"');
                content.push('/>');
                
                content.push('</div>');
                content.push('</div>');
            }
            
            //Close our wrapper
            content.push('</div>');
            
            var html = content.join('');
            html = $(html);

            var advancedEditor = html.find('.advanced');
            var advancedFields = advancedEditor.find('.advanced-field');
            
            //After building our HTML, we can add event listeners
            html.find('.btn-advanced').on('click', function(){
                //Simply unhide
                if(advancedEditor.hasClass('hidden')){
                    advancedEditor.removeClass('hidden');
                    return;
                }
                
                //Upon hiding, we should also reset all advanced fields
                advancedEditor.addClass('hidden');
                advancedFields.val('');
                
                advancedFields.trigger('change');
            });
            
            advancedFields.on('change', function() {
                //Set the value based on the field defined in our dataset
                gb[this.dataset['field']] = this.value;
            });
            
            //Initialize our advanced fields
            var expandAdvancedSettings = false;
            
            advancedFields.each(function(){
                var input = $(this);
                var field = this.dataset['field'];
                
                input.val(gb[field]);
                
                //Advanced settings should be expanded when at least one field has a value
                expandAdvancedSettings = expandAdvancedSettings || !!gb[field];
            });
            
            if(expandAdvancedSettings){
                advancedEditor.removeClass('hidden');
            }
            
            return html;
        },
        renderOrderBy: function(allColumns) {
            var col = this;
            var d = $('<div />', {
                'class': 'attribute',
                'data-attributeid': col.Id,
                'data-iid': col._id
            });
            var html = [
                '<div class="row">',
                '  <div class="col-xs-6">',
                '    <span class="fa fa-chevron-up btn-up"  title="', MDB.loadResourceString('Widget_Edit_Button_Up_Tooltip'), '"></span>',
                '    <span class="fa fa-chevron-down btn-down" title="', MDB.loadResourceString('Widget_Edit_Button_Down_Tooltip'), '"></span>',
                '    <span class="fa" title=""><input id="col_orderby_active_' + col._id + '" type="checkbox" class="orderby-active" /></span>',
                '    <label for="col_orderby_active_' + col._id + '" style="font-weight:normal;" class="col-name">' + (col.Type == 'expression' ? '' : col.Name) + "</label>",
                '  </div>',
                '  <div class="col-xs-6">',
                '     <select class="type" disabled="disabled" style="width:100px;">',
                '       <option value="0">' + MDB.loadResourceString('Widget_Edit_FilterDropdown_DefaultOption') + '</option>',
                '       <option value="1">COUNT</option>',
                '       <option value="4">COUNT DISTINCT</option>',
                '       <option value="2">AVG</option>',
                '       <option value="3">SUM</option>',
                '     </select>',
                //'  </div>',
                //'  <div class="col-xs-2">',
                '     <select class="orderby-direction" style="width:60px;">',
                '       <option value="0">' + MDB.loadResourceString('Widget_Edit_Section_OrderBy_ASC')+'</option>',
                '       <option value="1">' + MDB.loadResourceString('Widget_Edit_Section_OrderBy_DESC') + '</option>',
                '     </select>',
                '  </div>',
                '</div>'
            ].join('');
            d.html(html);
            if (col.Type == 'expression') {
                // remove type from 2nd div with dropdowns
                d.find('.col-xs-6').filter(':gt(0)').find('.type').remove();
                // enlarge 1st div
                d.find('.col-xs-6')
                    .filter(":lt(1)")
                    .removeClass('col-xs-6').addClass('col-xs-10')
                    .end()
                    .filter(':gt(0)')
                    .removeClass('col-xs-6').addClass('col-xs-2')
                    .end()
                    /* set expression: */
                    .find('label.col-name')
                    .text(col.Expression || col.Name || ' ')
                ;

            }
            d.find('input.title').val(col.Title || '').bind('change', function(e) {
                col.Title = this.value;
            });
            d.find('.orderby-active').prop('checked', !!col.OrderByEnabled).bind('change', function () {
                col.OrderByEnabled = this.checked;
                $('body').trigger('preview-sql');
            });
            d.find('.orderby-direction').val('' + (col.OrderByDirection || 0)).bind('change', function () {
                //col.OrderByEnabled = false;
                col.OrderByDirection = parseInt(this.value, 10);
                $('body').trigger('preview-sql');
            });
            d.find('.btn-up,.btn-down').bind('click', function() {
                var dir = 1;
                if ($(this).hasClass('btn-up')) {
                    dir = -1;
                }
                var index = allColumns.indexOf(col);
                var newIndex = index + dir;

                if (allColumns[newIndex]) {
                    var idx1 = col.OrderByIndex;
                    var idx2 = allColumns[newIndex].OrderByIndex;

                    col.OrderByIndex = idx2;
                    allColumns[newIndex].OrderByIndex = idx1;

                    $('body').trigger('re-render-model');
                    //$('body').trigger('preview-sql');
                }
            });

            col.on('typeChanged', function() {
                d.find('select.type').val(col.Operation || '');
            });
            d.find('select.type')
                .val(col.Operation || '');
            return d;
        },
        renderSelect: function() {
            var col = this;
            var d = $('<div />', {
                'class': 'attribute',
                'data-attributeid': col.Id,
                'data-iid': col._id
            });
            var html = [
                '<div class="row">',
                '  <div class="col-xs-8">',
                '    <span class="fa fa-trash-o btn-delete" title="' + MDB.loadResourceString('Widget_Edit_Button_Delete_Tooltip') + '"></span>',
                '    <span class="fa fa-gears btn-advanced" title="' + MDB.loadResourceString('Widget_Edit_Button_Advanced_Tooltip') + '"></span>',
                '    <span class="fa fa-filter btn-filter"  title="' + MDB.loadResourceString('Widget_Edit_Button_Filter_Tooltip') + '"></span>',
                '    <span class="fa fa-chevron-up btn-up"  title="' + MDB.loadResourceString('Widget_Edit_Button_Up_Tooltip') + '"></span>',
                '    <span class="fa fa-chevron-down btn-down" title="' + MDB.loadResourceString('Widget_Edit_Button_Down_Tooltip') + '"></span>',
                '    ' + col.Name,
                '  </div>',
                '  <div class="col-xs-4">',
                '     <select class="type">',
                '       <option value="0">' + MDB.loadResourceString('Widget_Edit_FilterDropdown_DefaultOption') + '</option>',
                '       <option value="1">COUNT</option>',
                '       <option value="4">COUNT DISTINCT</option>',
                '       <option value="2">AVG</option>',
                '       <option value="3">SUM</option>',
                '     </select>',
                '  </div>',
                '</div>',
                '<div class="row cexpression col-type-expression">',
                '  <div class="col-xs-12" style="padding-left:29px;">',
                '     <textarea placeholder="Expression" class="expression dropzone expression-dropzone"></textarea>',
                '     <div class="expression-message alert alert-danger"></div>',
                '  </div>',
                '</div>',
                '<div class="row advanced" style="display:none;">',
                '  <div class="col-xs-8" style="padding-left:29px;">',
                '     <input type="text" placeholder="' + MDB.loadResourceString('Widget_Edit_Section_Selection_Advanced_Title_Placeholder') + '" class="title" />',
                '  </div>'
            ].join('');

            if ($('.w-type').val() == types.TableExtended) {
                html += [
                    '  <div class="col-xs-4">',
                    '     <select class="data-format">',
                    '         <option value="">No data format</option>',
                    '         <option value="p">XX.XX %</option>',
                    '         <option value="p0">XX %</option>',
                    '         <option value="p1">XX.X %</option>',
                    '         <option value="p2">XX.XX %</option>',
                    '         <option value="p3">XX.XXX %</option>',
                    '         <option value="c3">€ XX.XXX</option>',
                    '     </select>',
                    '  </div>'
                ].join('');
            }

            html += [
                '</div>',
                '<div class="row cfilter">',
                '  <div class="col-xs-12" style="padding-left:29px;">',
                '     <input type="text" placeholder="' + MDB.loadResourceString('Widget_Edit_Section_Selection_Filter_Title_Placeholder') + '" class="filter" />',
                '  </div>',
                '</div>',
                '<div class="row cfilter">',
                '  <div data-groupnr="', col._id, '" class="col-xs-12 dropzone column-filter-dropzone" style="padding-left:29px;">',
                '     <span class="dz-info">' + MDB.loadResourceString('Widget_Edit_Section_Selection_Filter_Dropzone_Placeholder') + '</span>',
                '  </div>',
                '</div>'
            ].join('');
            d.html(html);

            d.find('input.title').val(col.Title || '').bind('change', function(e) {
                col.Title = this.value;
            });
            d.find('select.data-format').val(col.DataFormat || '').bind('change', function (e) {
                col.DataFormat = this.value;
            });
            d.find('select.type')
                .val(col.Operation || '')
                .bind('change', function(e) {
                    col.Operation = $(this).val();
                    col.emit('typeChanged',col.Operation );
                    $('body').trigger('preview-sql');
                });
            d.find('input.filter').val(this.FilterValue || '')
                .bind('change keyup', function(e) {
                    //TODO: should we validate the type?
                    col.FilterValue = this.value || null;
                    $('body').trigger('preview-sql');
                });
            d.find('.btn-filter').bind('click', function () {
                // show/hide filter
                col._filteropen = !col._filteropen;
                if (col._filteropen) {
                    d.find('.cfilter').show();
                } else {
                    d.find('.cfilter').hide();
                }
            });
            // init filter
            if (col._filteropen) {
                d.find('.cfilter').show();
            } else {
                d.find('.cfilter').hide();
            }

            d.find('.btn-advanced').bind('click', function () {
                var container = d.find('div.advanced');
                col._advancedopen = !col._advancedopen;
                if (col._advancedopen) {
                    container.show();
                } else {
                    container.hide();
                }
            });
            // init advanced
            if (col._advancedopen) {
                d.find('.advanced').show();
            } else {
                d.find('.advanced').hide();
            }

            if (this.Type == 'tag') {

                // remove expression fields
                d.find('.cexpression').remove();
                // remove dropzone
                d.find('input.filter').parents('.row').remove();
                d.find('.dropzone').parents('.row').remove();
            } else if (this.Type == 'expression') {
                // hide type selection
                d.find('select.type').hide().val('0');
                d.find('.cexpression').show().find('.expression').val(col.Expression || '').end();
                // remove dropzone, except for the expression
                d.find('input.filter').parents('.row').remove();
                d.find('.dropzone').not('.expression-dropzone').parents('.row').remove();

                //bind parser
                var container = d.find('.cexpression');
                container.find('.expression-message').hide();
                container.find('.expression').bind('blur', function () {
                    // repaint, todo: we could do this more efficiently
                    $('body').trigger('re-render-model');
                    //attribute-dropped
                }).bind('attribute-dropped', function (e, data) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!data || !data.attrId) {
                        return;
                    }
                    //data.type: expression, tag, undefined
                    if (data.type === undefined || data.type === 'attribute') {
                        // insert
                        var expression = $(this);
                        MDB.WidgetEditor.getMetaData().done(function (meta) {
                            var attrId = data.attrId;
                            var attribute = meta.AttributesById[attrId];
                            if (!attribute) {
                                console.warn("Attribute not found: " + attrId); return; 
                            }
                            var entityName = meta.Entities[attribute.EntityId].Name;
                            var attributeName = attribute.Name;
                            var val = expression.val();
                            if (val.length > 0 && val.substr(val.length - 2) != ' ') {
                                val += ' ';
                            }
                            val += entityName + '.' + attributeName;
                            expression.val(val);

                        });
                    }
                });
                // TODO: find a better place to do this
                MDB.WidgetEditor.Calc.startExpresssionMonitor(col, container, '.expression', function (err, expressionValue, ast) {
                    var lbl = container.find('.expression-message');
                    lbl.empty().hide();
                    if (!err && ast) {
                        // build ast
                        col.Expression = expressionValue;
                        console.log(ast);
                    }
                    if (err) {
                        // show error
                        var htmlMessage = "";
                        var message = "" + err;
                        if (err.name == 'SyntaxError') {
                            message = err.name + ": ";
                            //if (err.found !== undefined && err.found != null) message += 'Found: ' + err.found + " ";
                            message += err.message;
                            if (err.location && err.location.start) {
                                message += " on line " + err.location.start.line + ":" + err.location.start.column;
                                if (err.location.end) {
                                    // attempt to highlight the error in the expression
                                    try {
                                        var start = err.location.start,
                                            end = err.location.end;
                                        if (start.offset > 0) {
                                            htmlMessage += expressionValue.substring(0, start.offset);
                                        }

                                        htmlMessage += '<b class="expression-error">';
                                        htmlMessage += expressionValue.substring(start.offset, end.offset);
                                        htmlMessage += '</b>';
                                        if (end.offset > 0) {
                                            htmlMessage += expressionValue.substring(end.offset);
                                        }
                                    } catch (e) {
                                        // ignore error
                                        htmlMessage = "";
                                    }

                                }
                            }
                        }
                        //show error message

                        $('<span />').text(message).appendTo(lbl);
                        if (htmlMessage) {
                            $('<div />', {
                                'class': 'expression-message-source',
                                css: { 'whitespace': 'pre', 'font-weight': 'normal' }
                            }).html(htmlMessage).appendTo(lbl);
                        }
                        lbl.show();
                        //lbl.text(JSON.stringify(err, null, 2));
                        if (console.error) {
                            console.error(err)
                        }
                    }
                });
            } else {
                // remove expression fields
                d.find('.cexpression').remove();
                // configure dropzone
                var dz = d.find('.dropzone');
                if (col.FilterAttribute || col.FilterValue) {
                    d.addClass('has-filter');
                }
                if (this.FilterAttribute) {
                    // this.FilterAttribute
                    // remove dropzone & render attribute
                    //dz.removeClass('column-filter-dropzone').removeClass('dropzone');

                    var fa = this.FilterAttribute;
                    dz.find('.dz-info').hide();
                    $('<div class="dz-attrinfo"><span class="fa fa-trash-o btn-delete-filterattr"></span>&nbsp;<span class="name"></span></div>')
                        .find('.name')
                        .text(fa.Name || '')
                        .end()
                        .find('.btn-delete-filterattr')
                        .bind('click', function(e) {
                            e.preventDefault();
                            dz.find('.dz-attrinfo').remove();
                            dz.find('.dz-info').show();
                            if (!col.FilterValue) {
                                d.removeClass('has-filter');
                            }
                        })
                        .end()
                        .appendTo(dz);
                    MDB.WidgetEditor.WhereFilter.addAutocomplete(d.find('.cfilter:first input.filter'), fa.EntityId, fa.Name, fa.Type);
                }
            }

            return d;
        }
    });

    function Color(cfg) {
        if (!cfg) {
            cfg = {};
        }
        var me = this;
        this._id = 'CP' + (Color._idCount++);
        Object.keys(cfg).forEach(function (prop) {
            me[prop] = cfg[prop];
        });
    }

    Color._idCount = 0;
    Color.prototype = {
        constructor: Color,
        renderColorPicker: function () {
            var html = [
                '<div class="col-xs-4" data-iid="' + this._id + '" data-color="' + this.ColorValue + '">',
                '  <div class="colorpicker"></div> <i class="fa fa-trash-o btn-delete"></i>',
                '</div>'
            ].join('');
            return html;
        }
    }

})(jQuery, window);

